import axios from '../axios'
import constants from '../constants'
// import { store } from '../App'

// const errMsg = 'Server is unavailable.'

export const getUserContestList = (start, limit, sort, order, search, sd, ed, filters, isExport = false, type,token) => (dispatch) => {
  let qs = ''
  Object.entries(filters).forEach(([key, value]) => {
    if (key && value) {
      qs += `&${key}=${value}`
    }
  })
  axios.get(`/user-contest/admin/list?start=${start}&limit=${limit}&sort=${sort}&order=${order}&sd=${sd}&ed=${ed}&search=${search}&eType=${type}${qs}`, { headers: { Authorization: token } }).then((response) => {
    dispatch({
      type: isExport ? constants.EXPORT_USER_CONTEST_DATA : constants.USER_CONTEST_LIST,
      payload: {
        data: response?.data?.data || {},
        resStatus: true
      }
    })
  }).catch(() => {
    dispatch({
      type: constants.USER_CONTEST_LIST,
      payload: {
        data: {},
        resStatus: false
      }
    })
  })
}

export const clearUserContestExportData = () => ({
  type: constants.CLEAR_USER_CONTEST_EXPORT_DATA
})
